import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProjectApi, ProjectDTO, ProjectFilterDTO } from './ProjectApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faArrowLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ProjectStatusOptions } from '../../constants/projectConstants';
 
import { faEye, faEdit, faTrash, faComments, faFileUpload ,faTasks} from "@fortawesome/free-solid-svg-icons";
import {EntityType, UploadContexts} from '../../constants/globalConstants'
import ProjectActions from './ProjectActions';


const defaultFilters: ProjectFilterDTO = {
  status: '',
  projectType: '',
  contractBidId: '',
  projectName: '',
  description: '',
  contractBidNo: '',
  projectBidValue: undefined,
  projectActualValue: undefined,
  projectBidPercentage: undefined,
  licenseHolderName: '',
  givenStartDate: '',
  givenEndDate: '',
};

export const ProjectList: React.FC = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState<ProjectFilterDTO>(defaultFilters);
  const [projects, setProjects] = useState<ProjectDTO[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await ProjectApi.filter(filters);
      setProjects(res.data);
    } catch (err) {
      setError('Failed to fetch project data.');
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFilters(defaultFilters);
  };

  const handleDelete = async (id: string) => {
    if (confirm('Are you sure you want to delete this project?')) {
      await ProjectApi.delete(id);
      handleSearch();
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div className="p-4 bg-white rounded shadow">
      <button
        onClick={() => navigate(-1)}
        className="mb-4 inline-flex items-center text-sm text-blue-600 hover:underline"
      >
        <FontAwesomeIcon icon={faArrowLeft} className="mr-2" /> Back
      </button>

      <div className="mb-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Project Search</h1>
        <button
          onClick={() => navigate('/projects/create')}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 flex items-center text-sm"
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Create Project
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-gray-50 p-4 rounded mb-4 border">
        {Object.keys(defaultFilters).map((key) => {
          if (key === 'status') {
            return (
              <div key={key}>
                <label className="text-sm font-medium block mb-1">Status</label>
                <select
                  name="status"
                  value={filters.status || ''}
                  onChange={handleInputChange}
                  className="border px-3 py-2 rounded w-full"
                >
                  <option value="">All Statuses</option>
                  {ProjectStatusOptions.map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
              </div>
            );
          }

          return (
            <div key={key}>
              <label className="text-sm font-medium block mb-1">
                {key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase())}
              </label>
              <input
                type="text"
                name={key}
                value={(filters as any)[key] || ''}
                onChange={handleInputChange}
                className="border px-3 py-2 rounded w-full"
              />
            </div>
          );
        })}

        <div className="md:col-span-4 flex gap-2 mt-2">
          <button
            onClick={handleSearch}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center"
          >
            <FontAwesomeIcon icon={faSearch} className="mr-2" /> Apply Filters
          </button>
          <button
            onClick={handleReset}
            className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
          >
            Reset
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center">Loading...</div>
      ) : error ? (
        <div className="text-red-500">{error}</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-200 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">Project Name</th>
                <th className="p-2 border">Type</th>
                <th className="p-2 border">Status</th>
                <th className="p-2 border">Actual Value</th>
                <th className="p-2 border">Bid Value</th>
              
                <th className="p-2 border">Bid %</th>
                <th className="p-2 border">License Holder</th>
                <th className="p-2 border">Action</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((p) => (
                <tr key={p.id} className="hover:bg-gray-50">
                  <td className="p-2 border">{p.projectName}</td>
                  <td className="p-2 border">{p.projectType}</td>
                  <td className="p-2 border">{p.status}</td>
                 
                  <td className="p-2 border">₹{p.projectActualValue}</td>
                  <td className="p-2 border">₹{p.projectBidValue}</td>
                  <td className="p-2 border">{p.projectBidPercentage}%</td>
                  <td className="p-2 border">{p.licenseHolderName}</td>
                  <td className="p-2 border">
                   <ProjectActions project={p} onDelete={handleDelete} />
                </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};